import {Component, ElementRef, Input, OnChanges, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BlogMoreStoriesComponent} from "../../blog/blog-more-stories/blog-more-stories.component";
import {BlogVideoPopupComponent} from "../../blog/blog-video-popup/blog-video-popup.component";
import {LazyLoadImageModule} from "ng-lazyload-image";
import {PipeModule} from "../../pipe/pipe.module";
import {BlogDetails} from "../../blog/interface/blog-details";
import {ContentPreview} from "../../blog/interface/content-preview";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {ConstantService} from "../../services/constant.service";
import {StoryDetailsV2} from "../interface/story-details";
import {BlogDetailsContentFaqComponent} from "../../blog/blog-details-content-faq/blog-details-content-faq.component";
import {ContentSectionList} from "../../blog/interface/content-section-list";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'fb-story-details-content',
  standalone: true,
	imports: [CommonModule, BlogMoreStoriesComponent, BlogVideoPopupComponent, LazyLoadImageModule, PipeModule, BlogDetailsContentFaqComponent, RouterLink],
  templateUrl: './story-details-content.component.html',
  styleUrls: ['./story-details-content.component.scss']
})
export class StoryDetailsContentComponent implements OnChanges {

	@Input()
	public storyDetails: StoryDetailsV2 = {} as StoryDetailsV2;

	@Input()
	public storyRecommendedList: ContentPreview[] = [];

	public cdn: string = '';
	public urlLink = '';
	public openVid = false;
	public playVideo: boolean = false;
	public safeURL: SafeResourceUrl = '';

	@Input()
	public showCollapsedFaqs: boolean = false;

	public showCollapsedFaqsContent: boolean = false;
	public videoHeight: number = 0;
	public videoWidth: number = 0;

	@ViewChild('videoPoster', { static: false })
	private videoPoster: ElementRef<HTMLImageElement> =
		{} as ElementRef<HTMLImageElement>;

	private getEmbeddedURL(url: string): string {

		let id: string;

		if (ConstantService.YOUTUBE_VIDEO_REGEX.test(url)) {
			id = url.match(ConstantService.YOUTUBE_VIDEO_REGEX)![1];
			return 'https://www.youtube.com/embed/' + id + '?autoplay=1';
		} else if (ConstantService.VIMEO_VIDEO_REGEX.test(url)) {
			id = url.match(ConstantService.VIMEO_VIDEO_REGEX)![1];
			return 'https://player.vimeo.com/video/' + id + '?autoplay=1';
		} else {
			return '';
		}
	}

	constructor(private _sanitizer: DomSanitizer) {
	}

	ngOnChanges() {
		if(this.storyDetails && this.showCollapsedFaqs) {
			setTimeout(() => {
				this.showCollapsedFaqsContent = true;
			}, 3000)
		}
		else {
			this.showCollapsedFaqsContent = false;
		}
	}

	public getTitleId(option: ContentSectionList, index: number): string {
		let title: string = '';
		if(option.heading) {
			title = option.heading;
		}
		else if(option.title1) {
			title = option.title1;
		}
		else if(option.title2) {
			title = option.title2;
		}
		else if(option.templateType === 9 || option.templateType === 10) {
			title = option.image1Alt
		}
		return title? title.toLowerCase().replace(/\s+/g, '-') + '-' + (index + 1): 'section-' + (index + 1).toString();
	}


	public closeVideoModal(): void {
		this.openVid = false;
	}

	public openVideo(url: string): void {
		this.urlLink = url;
		this.openVid = true;
	}

	public getSafeUrl(url: string): SafeResourceUrl {
		return this._sanitizer.bypassSecurityTrustResourceUrl(this.getEmbeddedURL(url));
	}

	public playVideoInPlace(url: string): void {
		this.videoHeight = this.videoPoster? this.videoPoster.nativeElement.height : 450;
		this.videoWidth = this.videoPoster? this.videoPoster.nativeElement.width : 400;
		this.urlLink = url;
		this.safeURL = this.getSafeUrl(this.urlLink);
		this.playVideo = true;
	}
}
